export default __webpack_public_path__ + "static/threedoorways3-59b114cb1ed6ed197c48373299999fdc.gif";